import { supabase_stories } from "./supabase"






export async function GetStorageItem(props:{location: string}) {
    const { data, error } = await supabase_stories.storage.from('Stories').createSignedUrl(props.location, 60)  
    console.log(data, error)
    if (error) {
        console.error(error)
        return
    }
    return  { data, error } 
}


//     ((bucket_id = 'Stories'::text) AND (name = 'images/'::text) AND (( SELECT (auth.uid())::text AS uid) = '0d4c8b3b-4325-429c-a7e9-86d56e8571cf'::text))


// bucket_id = 'Stories' AND storage."extension"(name) = 'jpg' AND LOWER((storage.foldername(name))[1]) = 'public' AND auth.role() = 'anon'

//((bucket_id = 'Stories'::text) AND ((storage.foldername(name))[1] = 'images'::text) AND (auth.role() = 'authenticated'::text))
// 0d4c8b3b-4325-429c-a7e9-86d56e8571cf